import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Chip, Divider, Stack } from '@mui/material';
import { formatPriceWithSymbol } from './formatPrice.js';

const TYPE_GRADIENTS = {
  apartment: 'linear-gradient(135deg,#2196F3,#64B5F6)',
  villa: 'linear-gradient(135deg,#4CAF50,#81C784)',
  plot: 'linear-gradient(135deg,#FF9800,#FFB74D)',
  commercial: 'linear-gradient(135deg,#9C27B0,#BA68C8)',
};

export default function PropertyModal({ property, onClose }) {
  if (!property) return null;
  const pricePerSqft = Math.round(property.price / property.area);
  return (
    <Dialog open={Boolean(property)} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ height: 200, background: TYPE_GRADIENTS[property.type] }} />
      <DialogTitle sx={{ pb: 0 }}>
        {property.title}
        <Typography variant="body2" color="text.secondary">{property.locality}, {property.city}</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={1} sx={{ my: 2 }}>
          <Chip label={property.type} sx={{ textTransform: 'capitalize' }} color="primary" />
          <Chip label={`${property.area} sqft`} variant="outlined" />
        </Stack>
        <Typography variant="h4" fontWeight={800} color="primary" gutterBottom>
          {formatPriceWithSymbol(property.price)}
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="subtitle2" gutterBottom>Price Breakdown</Typography>
        <Stack spacing={0.5}>
          <Row label="Price per sqft" value={`₹${pricePerSqft.toLocaleString('en-IN')}`} />
          <Row label="Carpet Area" value={`${property.area} sqft`} />
          <Row label="Type" value={property.type} sx={{ textTransform: 'capitalize' }} />
          <Row label="Location" value={`${property.locality}, ${property.city}`} />
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Typography variant="subtitle2" gutterBottom>About</Typography>
        <Typography variant="body2" color="text.secondary">
          A premium {property.type} located in the prime area of {property.locality}, {property.city}.
          Spacious {property.area} sqft layout with modern amenities and excellent connectivity.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained">Contact Agent</Button>
      </DialogActions>
    </Dialog>
  );
}

function Row({ label, value }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography variant="body2" fontWeight={600} sx={{ textTransform: 'capitalize' }}>{value}</Typography>
    </Box>
  );
}
